'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSpiral = function TiSpiral(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 19.7c1.7-0.7 1.2-3 0-4-1.8-1.5-4.5-0.7-5.7 1.3-2.5 4 1.5 8.3 5.7 8.2 4.5-0.4 7.2-4.9 6.2-9-1.2-5-6.5-7.5-11.2-6-4.3 1.3-7 5.8-6.7 10.3 0.5 5 4.4 9 9.2 9.8 4.7 0.9 9.5-1.3 12-5.3 1.2-1.8 2-4 2-6.3 0-0.9 0.8-1.7 1.8-1.5 1.4 0 1.7 1.3 1.5 2.3-0.6 7.8-7.5 14.3-15.5 14.3-9.8 0-17.5-10.3-13.3-19.6 4.2-9 17.2-10.9 22.2-2 2.5 4.1 2 9.6-1.5 13.1-3.4 3.4-8.9 4-12.9 1.2-3.6-2.7-4.8-8.2-1.8-12 2.8-3.8 9.2-4 11.7 0.3 1.8 3.2 0 8.7-4.2 8.2-2.7 0-5-2.8-3.5-5.3 1-1.5 3.2-1 3.8 0.1 0.4 1.4 0.2 1.9 0.2 1.9z' })
        )
    );
};

exports.default = TiSpiral;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/spiral.js
// module id = 2033
// module chunks = 0